module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// D:/Code/Lynqu/npm/no-redux/node_modules/symbol-observable/index.js
// module id = 82
// module chunks = 0